<template>
  <v-app id="login" class="secondary lighten-1">
    <div id="login-bg-top" class="primary"></div>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4>
            <form @submit.prevent="onSignin">
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/transpress-logo.png" :alt="$t('app_title')" style="max-height: 30px">
                  <h1 class="flex my-4 primary--text font-weight-thin">{{ $t('app_title') }}</h1>
                </div>
                <v-form ref="loginForm">
                    <v-select prepend-icon="language"
                        :label="$t('Language')"
                        :items="globalConfig.langs" item-value="value" item-text="label" @change="lang" v-model="globalConfig.lang"></v-select>

                    <v-text-field  prepend-icon="person"
                        id="username"
                        name="username"
                        type="text"
                        :label="$t('Please enter username')"
                        :rules="required"
                        :error-messages="signErrors"
                        @keyup.enter="onSignin"
                        @keyup="signErrors = ''"
                        v-model="username"
                        required></v-text-field>

                    <v-text-field prepend-icon="lock"
                        id="password"
                        name="password"
                        type="password"
                        :label="$t('Please enter password')"
                        :rules="required"
                        :error-messages="signErrors"
                        @keyup.enter="onSignin"
                        @keyup="signErrors = ''"
                        v-model="password"
                        required></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn to="/register/" flat class="blue--text text--darken-1"><v-icon size="22" class="mr-2">person_add</v-icon>{{ $t('Register') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn type="submit" @click="onSignin" :loading="loading" class="secondary">
                  <v-icon size="22" class="mr-2">lock_open</v-icon>{{ $t('Sign in') }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <div class="pt-2 text-xs-center caption font-weight-light white--text" v-html="versionInfo"/>
            </form>

            <v-snackbar v-model="snackbar" value="true" right top multi-line color="error" :timeout="5000">
              {{ signErrors }}
              <v-btn dark flat @click="snackbar = false">
                {{ $t('OK')}}
              </v-btn>
            </v-snackbar>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { versionInfo } from "../../components/util.js"

export default {
  data() {
    return {
      username: "",
      password: "",
      loading : false,
      snackbar : false,
      signErrors : "",
      required : [(v) => !!v || this.$t("This field is required!")]
    };
  },
  computed: {
    ...mapGetters(['globalConfig']),
    versionInfo() {
      return versionInfo(this, true);
    }
  },
  methods: {
    ...mapActions(['changeLang', 'login', 'setUserConfigPrincipal']),

    onSignin() {
      if (!this.$refs.loginForm.validate())
        return;

      this.loading = true;
      this.signErrors = "";
      this.snackbar = false;
      this.login({
        username: this.username,
        password: this.password
      }).then((data) => {
        this.setUserConfigPrincipal(this.username);
        this.loading = false;
        // ignore duplicate navigation errors.
        this.$router.push(this.$route.query.redirect || '/').catch(e => {});
      }).catch((err) => {
        this.loading = false;
        this.setUserConfigPrincipal("");
        this.snackbar = true;
        if (err.status === 401){
          let errorMessage = "Authorization error";
          const parser = new DOMParser();
          const doc = parser.parseFromString(err.body, "text/html");
          const messageElement = doc.querySelector("p b+u");
          if (messageElement) {
            if (messageElement.textContent === "User is disabled")
              errorMessage = messageElement.textContent;
            if (messageElement.textContent === "User account is locked")
              errorMessage = messageElement.textContent;
          }
          this.signErrors = this.$t(errorMessage);
        }
        else if (err.status === 403)
            this.signErrors = this.$t("Permission error");
        else
            this.signErrors = this.$t("Unknown error");
      });
    },

    lang(val) {
      this.$i18n.locale = val;
      this.changeLang(val);
    },
  }
};
</script>

<style scoped lang="css">
#login-bg-top {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
button:hover {
  opacity: 0.7;
}
</style>
